import * as React from "react";
import { EmailNotificationModel } from "src/models/general-models";
import { ChangePassword, GetEmailNotification } from "src/server/utils/contact-utils";

interface Props {
    instance: string;
    loginKey: string;
}

interface State {
    newPassword: string;
    confirmPassword: string;
    ForgetEmail: EmailNotificationModel;
    isValidKey?: boolean
}

class ForgetPassword extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            newPassword: "",
            confirmPassword: "",
            ForgetEmail: Object(),
            isValidKey: true
        }
    }

    async componentDidMount() {
        this.getEmailNotification();
    }

    async getEmailNotification() {
        let { isValidKey } = this.state;
        const ForgetEmail = await GetEmailNotification(this.props.loginKey);
        const date = new Date(ForgetEmail.timestamp);
        const currentDate = new Date();
        date.setMinutes(date.getMinutes() + 5);


        if (currentDate < date)
            isValidKey = true;
        else {
            isValidKey = false;
        }
        this.setState({
            ForgetEmail,
            isValidKey
        });
    }

    async _savePassword() {
        let { confirmPassword, newPassword, ForgetEmail } = this.state;
        if (confirmPassword === newPassword) {
            await ChangePassword(ForgetEmail.userOntology, confirmPassword);
            window.location.hash = `/${this.props.instance}`
        }
        else {
            alert("Password does not match")
        }
        this.setState({
            confirmPassword: "",
            newPassword: "",
        })
    }

    handlePassword(Password: string) {
        let newPassword = this.state.newPassword;
        newPassword = Password; this.setState({ newPassword });
    }

    handleConfirmPassword(ConfirmPassword: string) {
        let confirmPassword = this.state.confirmPassword;
        confirmPassword = ConfirmPassword; this.setState({ confirmPassword });
    }

    render() {
        const { newPassword, confirmPassword, isValidKey, ForgetEmail } = this.state
        return (
            <div className="container">
                <div className="card card-container" style={{ maxWidth: "450px" }} id="divLogin">
                    <div className="divimg"><img id="profile-img" className="companyLogo" src="assets/img/new logo.png" /></div>
                    <p id="profile-name" className="profile-name-card"></p>
                    {isValidKey && <>
                        <div className="row padding-10">
                            <div className="col-md-12">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="user">User Name</label>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <input type="text" disabled={true} id="user" name="user" className="form-control" value={ForgetEmail.userOntology} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="newpassword">New Password</label>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <input type="password" id="newpassword" className="form-control" value={newPassword} onChange={(e) => this.handlePassword(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <label htmlFor="confirmpassword">Confirm Password</label>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <input type="password" id="confirmpassword" className="form-control" value={confirmPassword} onChange={(e) => this.handleConfirmPassword(e.target.value)} />
                                </div>
                            </div>
                            <button className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={async () => {
                                await this._savePassword();
                            }} >Change Password</button>
                        </div>
                    </>}
                    {
                        !isValidKey && <>
                            <div className="row padding-5">
                                <div className="col-md-12 center">
                                    <div className="login-form__header">Invalid Request!</div>
                                </div>
                                <br />
                                <div className="col-md-12">
                                    <p>The email key has expired. You can get new key to reset your Password. </p>
                                    <button className="btn btn-lg btn-fill btn-dark btn-block" type="button" onClick={async () => {
                                        window.location.hash = `/${this.props.instance}/forget-password`
                                    }} >Reset Password</button>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        )
    }
}

export default ForgetPassword;



// WEBPACK FOOTER //
// ./src/Components/People/ForgetPassword.tsx